import * as utils from '../utils';
import { launchChrome } from '../commons/chrome-launcher';
import type { IReporter } from './IReporter';
import type { RunnerOptions } from '../runOptions';
import type { TestRunStatusTestResult } from '../testRunStatus';

class ChromeReporter implements IReporter {
    constructor(private readonly options: RunnerOptions, private readonly branchToUse: string) {}

    public onTestStarted(test: TestRunStatusTestResult) {
        const testUrl = utils.getTestUrl(this.options.editorUrl!, this.options.project, test.testId, test.resultId, this.branchToUse);
        return launchChrome(testUrl);
    }
}

export const Reporter = ChromeReporter;
